import { Exclude, Type } from 'class-transformer'
import {
  IsBoolean,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator'
import _ from 'lodash'
import { BaseSchema } from './BaseSchema'

export class CarrierSchema extends BaseSchema {
  /**
   * User ID
   */
  @IsOptional()
  @IsUUID()
  id: string

  /**
   * Code
   */
  @Type(() => String)
  @IsNotEmpty()
  @IsString()
  name: string = null

  /**
   * Tracking number prefix.
   */
  @IsOptional()
  @Type(() => String)
  @IsOptional()
  @IsString()
  trackingNumberPrefix: string = ''

  /**
   * Tracking url
   */
  @Exclude({ toPlainOnly: true })
  @IsOptional()
  @Type(() => String)
  @IsOptional()
  @IsString()
  trackingUrl: string

  /**
   * Is Enabled?
   */
  @Type(() => Boolean)
  @IsNotEmpty()
  @IsBoolean()
  isEnabled: boolean = true

  /**
   * Date created
   */
  @Type(() => Date)
  created: Date

  /**
   * Updated by
   */
  createdBy: string

  /**
   * Date updated
   */
  @Type(() => Date)
  updated: Date

  /**
   * Updated by
   */
  updatedBy: string

  /**
   * Date deleted
   */
  @Type(() => Date)
  deleted: Date

  /**
   * Deleted by
   */
  deletedBy: string

  /**
   * Construct
   * @param data
   */
  constructor (data?: Partial<CarrierSchema>) {
    super()
    _.assign(this, data)
  }

  /**
   * Returns a string for sorting
   * @returns string
   */
  getSortingValue () {
    return `${this.name}`
  }
}
